import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tax-tariff-tranche-history.reducer';

export const TaxTariffTrancheHistoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const taxTariffTrancheHistoryEntity = useAppSelector(state => state.taxTariffTrancheHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="taxTariffTrancheHistoryDetailsHeading">
          <Translate contentKey="crawlerBackendApp.taxTariffTrancheHistory.detail.title">
            TaxTariffTrancheHistory
          </Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{taxTariffTrancheHistoryEntity.id}</dd>
          <dt>
            <span id="tariff">
              <Translate contentKey="crawlerBackendApp.taxTariffTrancheHistory.tariff">Tariff</Translate>
            </span>
          </dt>
          <dd>{taxTariffTrancheHistoryEntity.tariff}</dd>
          <dt>
            <span id="effectiveDate">
              <Translate contentKey="crawlerBackendApp.taxTariffTrancheHistory.effectiveDate">Effective Date</Translate>
            </span>
          </dt>
          <dd>
            {taxTariffTrancheHistoryEntity.effectiveDate ? (
              <TextFormat
                value={taxTariffTrancheHistoryEntity.effectiveDate}
                type="date"
                format={APP_LOCAL_DATE_FORMAT}
              />
            ) : null}
          </dd>
          <dt>
            <span id="expirationDate">
              <Translate contentKey="crawlerBackendApp.taxTariffTrancheHistory.expirationDate">
                Expiration Date
              </Translate>
            </span>
          </dt>
          <dd>
            {taxTariffTrancheHistoryEntity.expirationDate ? (
              <TextFormat
                value={taxTariffTrancheHistoryEntity.expirationDate}
                type="date"
                format={APP_LOCAL_DATE_FORMAT}
              />
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.taxTariffTrancheHistory.taxTariffTrancheType">
              Tax Tariff Tranche Type
            </Translate>
          </dt>
          <dd>
            {taxTariffTrancheHistoryEntity.taxTariffTrancheType
              ? taxTariffTrancheHistoryEntity.taxTariffTrancheType.type
              : ''}
          </dd>
        </dl>
        <Button tag={Link} to="/tax-tariff-tranche-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button
          tag={Link}
          to={`/tax-tariff-tranche-history/${taxTariffTrancheHistoryEntity.id}/edit`}
          replace
          color="primary"
        >
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TaxTariffTrancheHistoryDetail;
